import { pageRoutes } from "../../../routes";

export const getChatPath = (clientCode: string, threadId?: string): string =>
  threadId ? `/${clientCode}/${pageRoutes.assistant}/${threadId}` : `/${clientCode}/${pageRoutes.assistant}`;

export const getTaskPath = (clientCode: string, taskId: string): string =>
  `/${clientCode}/${pageRoutes.assistant}/tasks/${taskId}`;
